import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { User, UserService } from '../../core';
import * as AppConfig from '../../app.config';
import { AbstractBaseComponent } from '../abstract-base.component';
import { NavigationEnd, Router } from "@angular/router";
import { AccountService } from '../../api';
import { takeUntil } from 'rxjs/operators';


@Component({
    selector: 'my-global-navigation',
    templateUrl: 'global-navigation.component.html',
    styleUrls: ['global-navigation.component.scss']
})

export class GlobalNavigationComponent extends AbstractBaseComponent implements OnInit {

    readonly isDev = AppConfig.isDev;

    /** User's display name */
    userName: string|null = null;

    /** User's avatar - current name initials */
    userAvatar: string|null = null;

    /** User's role */
    isNurse: boolean = false;
    isDON: boolean = false;
    isCorporate: boolean = false;
    isUserAdmin: boolean = false;
    isBusinessOffice: boolean = false;
    isImpersonating: boolean = false;

    tooSmall: boolean = window.innerWidth < 1060;
    selectedRoute: string = '';

    constructor(private userSvc: UserService, private router: Router, cdr: ChangeDetectorRef, private accountSvc: AccountService) {
        super();

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.selectNav();
            }
        });

        window.onresize = (e) =>
        {
            this.tooSmall = window.innerWidth < 1060;
            cdr.detectChanges(); //running change detection manually
        };
    }

    /** Initialize component */
    ngOnInit(): void {
        this.userSvc.user$.pipe(takeUntil(this.destroy$)).subscribe((user) => this.onUserLoginChanged(user));
    }

    /**
     * React to change in user authentication state by showing or hiding the navigation,
     * and updating information based on the user's details.
     * @param user the new authenticated User, or null upon logout.
     */
    private onUserLoginChanged(user: User|null): void {
        if (user) {
            this.userName = user.name;
            this.userAvatar = user.firstName[0] + user.lastName[0]; //turn name into acronym
            this.isNurse = this.userSvc.isNurse;
            this.isDON = this.userSvc.isDON ;
            this.isCorporate = this.userSvc.isCorporate;
            this.isUserAdmin = this.userSvc.isUserAdmin;
            this.isBusinessOffice = this.userSvc.isBusinessOffice;
            this.isImpersonating = (user.isImpersonating === true);
        }
        else {
            this.userName = null;
            this.userAvatar = null;
            this.isNurse = false;
            this.isDON = false;
            this.isCorporate = false;
            this.isUserAdmin = false;
            this.isBusinessOffice = false;
            this.isImpersonating = false;
        }
    }

    public selectNav(){
        let route = this.router.routerState.snapshot.url;
        // if(route.indexOf('alerts') > 0 ){
        //     this.selectedRoute = 'Alerts';
        // }else{
             this.selectedRoute = route.split('/')[1];
        // }
    }
}
